import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { LOGOUT_REDIRECT_PATHS } from "npmlinks-constants";
import { isApp, isIframe, isMybagCheckout } from "../../utils";
import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";
import StaticHeader from "./StaticHeader";
import BreadcrumbList from "../BreadcrumbList";

let HeaderComponent;
// TODO: need to add dynamic import for component or route based
@inject("LoginStore", "MybagStore", "CommonStore")
@observer
class Header extends Component {
  static contextTypes = {
    router: PropTypes.shape({
      staticContext: PropTypes.object,
    }),
  };

  componentWillMount() {
    let localIsDesktop = false;
    let localIsStatic = false;
    const { isDesktop } = this.props.CommonStore;
    const { staticContext } = this.context.router;

    if (staticContext) {
      localIsDesktop =
        (staticContext.globalConfig && staticContext.globalConfig.isDesktop) ||
        false;
      localIsStatic =
        (staticContext.globalConfig &&
          staticContext.globalConfig.staticHeader) ||
        false;
    } else {
      localIsDesktop = isDesktop;
      localIsStatic = (window && window.GL && window.GL.staticHeader) || false;
    }
    HeaderComponent =
      (localIsStatic && StaticHeader.component) ||
      (localIsDesktop && DesktopHeader.component) ||
      MobileHeader.component;
    // (isMybagCheckout() && PlainHeader) ||
  }
  componentDidMount() {
    // eslint-disable-next-line react/prop-types
    if (this.props.LoginStore.checkUserRoles()) {
      this.props.LoginStore.logoutAction();
      this.props.MybagStore.clearCart();
      if (LOGOUT_REDIRECT_PATHS.includes(window.pageType)) {
        window.location = "/";
      }
    }
  }
  componentDidCatch(error, errorInfo) {
    console.error(`error in header ${error} ${errorInfo} ${this}`);
  }
  get staticHeader() {
    const { staticContext } = this.context.router;
    const globalConfigVar =
      (window && window.GL) || (staticContext && staticContext.globalConfig);
    const staticHeader =
      (globalConfigVar && globalConfigVar.staticHeader) ||
      isMybagCheckout() ||
      false;
    return staticHeader;
  }
  get isMybagCheckoutPage() {
    return this.staticHeader ? "nw-mybag-checkout" : "";
  }
  get hideHeader() {
    const { staticContext } = this.context.router;
    const globalConfigVar =
      (window && window.GL) || (staticContext && staticContext.globalConfig);
    return (globalConfigVar && globalConfigVar.noHeader) || false;
  }

  render() {
    if (isApp || isIframe || this.hideHeader) {
      return null;
    }
    return (
      <Fragment>
        <div className={`nw-header-container ${this.isMybagCheckoutPage}`}>
          <HeaderComponent />
        </div>
        <BreadcrumbList.component />
      </Fragment>
    );
  }
}

export * as ActionButtons from "./ActionButtons";
export * as DesktopHeader from "./DesktopHeader";
export * as MobileHeader from "./MobileHeader";
export { default as StaticHeader } from "./StaticHeader";
export { default as TopbarText } from "./TopbarText";

Header.wrappedComponent.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
  MybagStore: PropTypes.shape({
    clearCart: PropTypes.func.isRequired,
  }).isRequired,
  LoginStore: PropTypes.shape({
    logoutAction: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("LoginStore", "MybagStore", "CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: Header,
  component: Header,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Header/index.js